import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=ee5a43fc&"
import script from "./Base.ts?vue&type=script&lang=js&"
export * from "./Base.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports